import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Params,
  Router,
} from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { UploadDocumentModel } from 'common/models/page-models/applicants/upload-document/upload-document-data.model';
import {
  RouteEnvelope,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { UploadDocumentWidgetService } from 'common/widget/applicant-dashboard/upload-document-widget.service';

@Injectable({
  providedIn: 'root',
})
export class UploaddocumentResolver extends FormResolverService<UploadDocumentModel> {
  constructor(
    protected fs: UploadDocumentWidgetService,
    protected override router: Router,
    protected override systemService: SystemService,
    private aRoute: ActivatedRoute
  ) {
    super(fs, router, systemService);
  }

  // override getDataBaseOnMessage(message: RouteEnvelope, body: any = ''): Promise<any> {
  // }

  override manageState() {
   
    // console.log(this.aRoute.queryParams);
    const envelope = new RouteEnvelope();
    envelope.type = OperationType.UPDATE;
    //    console.log(this.aRoute)

    envelope.transferData = new WidgetModel();
    
    // envelope.transferData.transferData = this.getQueryParam();
    return envelope;
  }

//   getQueryParam()
//   {
//     let id;
//     this.aRoute.queryParams.subscribe((params: Params) => {
//       console.log(params['id']);
//       id = params['id'];
//       console.log(id,params['id'],'===')
//       return id;
//     });
//   }

  //   override manageState(): Promise<RouteEnvelope> {
  //     return new Promise((resolve) => {
  //       const envelope = new RouteEnvelope();
  //       envelope.type = OperationType.UPDATE;

  //       const widgetModel = new WidgetModel();

  //       this.aRoute.queryParams.subscribe((params: Params) => {
  //         console.log(params['id']); // Log the 'id' parameter
  //         widgetModel.transferData = params['id']; // Assign the value
  //         envelope.transferData = widgetModel; // Assign the WidgetModel to the envelope

  //         resolve(envelope); // Resolve the promise with the envelope
  //       });
  //     });
  //   }
}
